import { jsxs as e, jsx as r } from "react/jsx-runtime";

import { useState as o, useCallback as i, createElement as l } from "react";

import n from "../../hooks/useId/index.js";

import t from "../../utils/classNames/index.js";

import a from "./TabLabel/index.js";

import s from "./useFlatChildrenProps/index.js";

import { getTabListId as d, getTabPanelId as c, getTabId as m, stepTo as f } from "./utils/index.js";

const h = {
    ArrowLeft: (e, r, o, i) => f(e, r, o, i, -1),
    ArrowRight: (e, r, o, i) => f(e, r, o, i, 1)
}, p = {
    ArrowUp: h.ArrowLeft,
    ArrowDown: h.ArrowRight
}, u = ({children: e}) => e, w = () => null, x = ({id: f, value: w, onChange: x, className: g, children: v = [], vertical: b = !1, TabsListContainer: y = u, contentClassName: j, ...A}) => {
    const N = n(f && f + ":"), [C, L] = o(w), k = i((e => {
        L(e), x?.(e);
    }), [ x ]);
    void 0 !== w && w !== C && L(w);
    const D = s(v);
    if (!D.length) return null;
    const I = Math.max(0, D.findIndex((e => C === e.value))), P = D[I], R = b ? p : h;
    /*
          Grid must be used instead of flex. There could be problems with scrollable tabslist with flex.
      */
    return e("div", {
        className: t("grid", b ? "grid-flow-row grid-cols-[min-content,auto]" : "grid-flow-col grid-rows-[min-content,auto]", g),
        ...A,
        children: [ r(y, {
            children: r("div", {
                role: "tablist",
                id: d(N),
                className: t("typography-body-l flex overflow-auto whitespace-nowrap", b ? "flex-col" : ""),
                onKeyDown: e => R[e.key]?.(e, N, D, I),
                children: D.map((e => l(a, {
                    ...e,
                    key: e.value,
                    onChange: k,
                    idPrefix: N,
                    selected: e === P
                })))
            })
        }), r("div", {
            role: "tabpanel",
            className: j,
            id: c(N),
            "aria-labelledby": m(N, P.value),
            children: P.children
        }) ]
    });
};

export { w as Tab, x as Tabs };
//# sourceMappingURL=index.js.map
